export default {
  'user.title': 'Account',
  'user.persona': 'Personal data',
  'user.name': 'Name',
  'user.name.description': 'Change name',
  'user.birthday': 'Date of birth',
  'user.birthday.description': 'Change date of birth',
  'user.password': 'Password',
  'user.password.description': 'Change password',
  'user.email': 'Email',
  'user.email.change-notice': 'Change email - Go to support',
  'user.phone': 'Phone number',
  'user.phone.description': 'Change phone number',
  'user.contact': 'Contact',
  'user.insurance': 'Insurance',
  'user.insurance-type': 'Insurance type',
  'user.insurance-type-change': 'Change insurance type',
  'user.insurance-number': 'Personal Insurance Number',
  'user.insurance-number-change': 'Change insurance number',
  'user.insurance-number-add': 'Add insurance number',
  'user.insurer-number': 'Health Insurer Number',
  'user.insurer-number-change': 'Change insurer number',
  'user.insurer-number-add': 'Add insurer number',
  'user.insurance.action': 'Insurance',
  'user.insurance.add': 'Add insurance information',
  'user.insurance.change': 'Change insurance information',
  'user.delete-account': 'Delete account',

  'user.verification': 'Email verification',
  'user.verified': 'Email was confirmed',
  'user.not-verified': 'Email confirmation pending. Click here to resend the email.',
  'user.not-verified.resent':
    'Verification email has been sent. Renewed e-mail delivery is no longer possible.',

  'change-name': 'Change name',
  'change-name.first-name': 'First name',
  'change-name.last-name': 'Last name',
  'change-name.success': 'Name was changed successfully',
  'change-name.error': 'Name could not be changed',

  'change-birth-date': 'Change date of birth',
  'change-birth-date.success': 'Date of birth was changed successfully',
  'change-birth-date.error': 'Date of birth could not be changed',

  'change-phone-number': 'Change phone number',
  'change-phone-number.success': 'Phone number was changed successfully',
  'change-phone-number.error': 'Phone number could not be changed',

  'change-password': 'Change password',
  'change-insurance': 'Change insurance information',
  'change-insurance.success': 'Insurance information updated successfully',
  'change-insurance.error': 'An error occurred while updating insurance information',
  'change-password.success': 'Password was changed successfully',
  'change-password.success.description': 'Please log in again',
  'change-password.old-password': 'Old password',
  'change-password.new-password': 'New password',
  'change-password.new-password.repeat': 'Repeat new password',
  'change-password.required-field': 'Please fill in all indicated fields',

  'account-details': 'Account information',

  'set-new-password': 'Set new password',
  'set-new-password.description': 'Please enter your new password twice.',

  // Reset password
  'reset-password.sent': 'Please check your mailbox',
  'reset-password.success': 'Password was reset',
  'reset-password.sent.description':
    'If an account already exists with the e-mail address you entered, a link to reset the password will be sent to this address.',
  'reset-password': 'Reset password',
  'reset-password.error':
    'Your password could not be reset. Please check the email address you entered.',
  'reset-password.description':
    'Please enter the email address you used to create the account. You will receive an email with a link to reset.',
  'prepare-password-reset.error':
    'Your password could not be reset. Please check the email address you entered.',
  'prepare-password-reset.title': 'Reset password',
  'prepare-password.reset.description':
    'Please enter the email address you used to create the account. You will receive an email with a link to reset.',

  // Account deletion
  'account-deletion': 'Account deletion',
  'account-deletion.p1':
    'Because your account can be linked to clinical and operational records within a hospital, we can’t fully delete the account record itself without risking the integrity of those records.',
  'account-deletion.p2':
    'Instead, when you request “account deletion”, we anonymize your personal data. This means your profile is disconnected from you as a person, while hospital records that must remain consistent and auditable stay intact.',

  'account-deletion.what-we-do': 'What we do',
  'account-deletion.what-we-do.p1': 'By deleting your account, we will:',
  'account-deletion.what-we-do.ul1':
    'Remove or remove personal identifiers (e.g., name, email address, phone number, profile details)',
  'account-deletion.what-we-do.ul2': 'Disable access to the account so you can no longer sign in',
  'account-deletion.what-we-do.ul3':
    'Keep non-personal, hospital-related references that are required for documentation, traceability, and system integrity',
  'account-deletion.delete-account': 'Delete account',
  'account-deletion.delete-account.popconfirm':
    'Are you sure you want to delete your account? This action cannot be undone.',
  'account-deletion.success': 'Your account has been successfully deleted.',
  'account-deletion.modal-title': 'Account deleted',
  'account-deletion.go-to-home-screen': 'Go to home screen',
  'account-deletion.password-modal.title': 'Are you sure that you want to delete your account?',
  'account-deletion.password-modal.description':
    'Please enter your password to confirm deletion. This action cannot be undone.',
  'account-deletion.password-modal.secondary-button': 'Cancel',
  'account-deletion.generic-error': 'Something went wrong. Please check your access data',
};
